import Compressor from 'compressorjs';
import { logger } from 'monitor';

export const compressImage = (photo: File) => {
  return new Promise((resolve: (value: File) => void) => {
    new Compressor(photo, {
      error: (error) => logger.error(error.message, error),
      maxHeight: 4000,
      maxWidth: 4000,
      quality: 0.9,
      retainExif: true,
      success: (compressedFile: File) => {
        logger.info('Image compressed', {
          compressedSize: compressedFile.size,
          originalSize: photo.size,
          percentage: Math.round((compressedFile.size / photo.size) * 100),
        });
        resolve(compressedFile);
      },
    });
  });
};
